// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideUnfoldVertical as RawLucideUnfoldVertical } from "lucide-react";
export const LucideUnfoldVertical = /* @__PURE__ */ createIcon(RawLucideUnfoldVertical, "LucideUnfoldVertical", 2);
